"use strict";
const angular = require("angular");

export class incidentSharingComponent {
  constructor(appConfig) {
    "ngInject";

    this.constants = appConfig;
  }
}

export default angular
  .module("hccApp.incidentSharing", [])
  .component("incidentSharing", {
    template: require("./incidentSharing.html"),
    bindings: { incident: "=" },
    controller: incidentSharingComponent
  }).name;



// WEBPACK FOOTER //
// ./client/app/incident/incidentSharing/incidentSharing.component.js